<template>
    <div :class="classes" :style="styles">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'link-col',
        props: {
            span: [Number, String],
            order: [Number, String],
            offset: [Number, String],
            push: [Number, String],
            pull: [Number, String],
            className: String,
            xs: [Number, Object],
            sm: [Number, Object],
            md: [Number, Object],
            lg: [Number, Object]
        },
        data() {
            return {gutter: 0};
        },
        computed: {
            classes() {
                let classes = [
                    'link-col',
                    {
                        [`link-col-span-${this.span}`]: !!this.span,
                        [`link-col-order-${this.order}`]: !!this.order,
                        [`link-col-offset-${this.offset}`]: !!this.offset,
                        [`link-col-push-${this.push}`]: !!this.push,
                        [`link-col-pull-${this.pull}`]: !!this.pull,
                        [`${this.className}`]: !!this.className,
                    }
                ];

                ['xs', 'sm', 'md', 'lg'].forEach(size => {
                    if (typeof this[size] === 'number') {
                        classes.push(`link-col-${size}-${this[size]}`);
                    }
                    else if (typeof this[size] === 'object') {
                        let props = this[size];
                        Object.keys(props).forEach(prop => {
                            classes.push(
                                prop !== 'span'
                                    ? `link-col-${size}-${prop}-${props[prop]}`
                                    : `link-col-span-${size}-${props[prop]}`
                            );
                        });
                    }
                });

                return classes;
            },
            styles() {
                let style = {};
                if ((this.gutter - 0) !== 0) {
                    style = {
                        paddingLeft: (this.gutter - 0) / 2 + 'px',
                        paddingRight: (this.gutter - 0) / 2 + 'px'
                    };
                }
                return style;
            }
        },
        methods: {
            updateGutter() {
                const row = this.$parent;
                if (row.$options.name !== 'link-row') {
                    console.error('update gutter failed, col must be wrapped by row!');
                    return;
                }
                row.updateGutter();
            }
        },
        mounted() {
            this.updateGutter();
        },
        beforeDestroy() {
            this.updateGutter();
        }
    };
</script>
